import { MeResponseSchema, type LoginRequest, type MeResponse } from "@bube-hq/contracts/auth";
import { z } from "zod";
import { paths } from "./paths.js";
import { request } from "./http.js";

// Only authentication schemas belong to the login bundle. The authenticated client reuses this object.
export const authApi = {
  login: (body: LoginRequest): Promise<MeResponse> =>
    request(paths.auth.login(), { method: "POST", body, schema: MeResponseSchema }),

  devLogin: (): Promise<{ email: string }> =>
    request(paths.auth.devLogin(), { method: "POST", schema: z.object({ email: z.string() }) }),

  me: (signal?: AbortSignal): Promise<MeResponse> =>
    request(paths.auth.me(), { schema: MeResponseSchema, signal }),

  logout: (): Promise<void> =>
    request(paths.auth.logout(), {
      method: "POST",
      schema: z.unknown().transform(() => undefined),
    }),

  changePassword: (body: { currentPassword: string; newPassword: string }): Promise<MeResponse> =>
    request(paths.auth.changePassword(), { method: "POST", body, schema: MeResponseSchema }),
};
export { HqApiError } from "./errors.js";
